var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionCloudUploadColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C2.68629 20 0 17.3137 0 14C0 10.6863 2.68629 8 6 8C6.02337 8 6.04671 8.00013 6.07003 8.0004C7.45321 5.60897 10.0387 4 13 4C17.1632 4 20.5837 7.18015 20.9647 11.2438C22.5796 11.7994 23.7789 13.2481 23.9725 15H24C24 15.0861 23.9978 15.1716 23.9935 15.2566C23.9978 15.3372 24 15.4183 24 15.5C24 17.9853 21.9853 20 19.5 20H6Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H11V16H8.76759C8.34366 16 8 15.6563 8 15.2324C8 15.0809 8.04486 14.9327 8.12892 14.8066L11.7227 9.41603C11.8959 9.15612 12.1876 9 12.5 9C12.8124 9 13.1041 9.15612 13.2773 9.41602L16.8711 14.8066C16.9551 14.9327 17 15.0809 17 15.2324C17 15.6563 16.6563 16 16.2324 16H14V20Z",
    fill: "url(#paint0_linear_9_8727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_8727",
    x1: 12.5,
    y1: 9,
    x2: 12.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FFCC33",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC33",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionCloudUploadColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_cloud_upload_colored_day.62065f408d6243be22830baf620b0a71.svg";
export { ForwardRef as ReactComponent };